import React from 'react';
import { Italic } from 'styled-icons/boxicons-regular/Italic';

function ItalicIcon(props) {
  return (
    <Italic {...props} className={'icon'} />
  );
}

export default ItalicIcon;
